var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 104,
    viewBox: "0 0 71 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1665 38.5002C68.3992 35.4161 66.8333 32.4741 64.145 30.9447L32.9219 13.1821C28.3421 10.5767 22.5381 13.0333 21.2203 18.1349L2.96939 88.7909C1.68416 93.7665 5.35635 98.6461 10.4933 98.7886L55.8808 100.048C60.1495 100.166 63.7586 96.9111 64.08 92.6529L68.1665 38.5002Z",
    fill: "#1B1717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1438 35.4892C68.3692 32.5015 66.8522 29.6514 64.2479 28.1698L33.0248 10.4072C28.5882 7.88325 22.9655 10.2631 21.6889 15.2052L3.43801 85.8612C2.19294 90.6813 5.75038 95.4084 10.7268 95.5465L56.1143 96.8057C60.2496 96.9205 63.7459 93.7671 64.0572 89.6419L68.1438 35.4892Z",
    fill: "#404043",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.121 32.4782C68.3392 29.5868 66.8712 26.8287 64.3509 25.3949L33.1278 7.63234C28.8342 5.18978 23.393 7.49283 22.1576 12.2755L3.90663 82.9316C2.70172 87.5962 6.1444 92.1708 10.9603 92.3044L56.3478 93.5636C60.3497 93.6747 63.7333 90.623 64.0345 86.6309L68.121 32.4782Z",
    fill: "#232222",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.762 33.838C65.9863 30.8667 64.4872 28.0301 61.906 26.5414L34.2613 10.597C29.8158 8.03302 24.1509 10.4198 22.8805 15.3919L6.35288 80.0787C5.122 84.8962 8.68193 89.6101 13.6524 89.7444L54.0641 90.8361C58.1973 90.9477 61.6903 87.7951 62.0014 83.6721L65.762 33.838Z",
    fill: "url(#paint0_linear_9071_7557)",
    stroke: "#18790C",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9071_7557",
    x1: 32.5483,
    y1: 91.906,
    x2: 39.0197,
    y2: 6.14981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143B18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010301"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectright);
export default __webpack_public_path__ + "static/media/rectright.96dd5c7cd3a66f1d1c5163a3e9a9159b.svg";
export { ForwardRef as ReactComponent };